import { MatDateFormats } from '@angular/material/core';

/**
 * Custom date format configuration for Angular Material datepicker
 *
 * Format specifications:
 * - dateInput: Format displayed in the input field → "01 April 2025"
 * - monthYearLabel: Format for calendar header → "Apr 2025"
 * - dateA11yLabel: Accessible label format for dates
 * - monthYearA11yLabel: Accessible label format for month/year
 */
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'input', // Delegates to AppDateAdapter.parse()
  },
  display: {
    dateInput: 'input',            // Uses AppDateAdapter.format() → "01 April 2025"
    monthYearLabel: 'MMM yyyy',    // Calendar header format → "Apr 2025"
    dateA11yLabel: 'LL',           // Screen reader format for date
    monthYearA11yLabel: 'MMMM yyyy', // Screen reader format for month/year
  },
};
